// extracted by mini-css-extract-plugin
module.exports = {"Form":"Form_Form__R1Z1E","rc-anchor-container":"Form_rc-anchor-container__B2aMY","rc-anchor-light":"Form_rc-anchor-light__RbhG5"};